/* Product gallery autoplay: advances one slide every 5s, looping back to
   the first after the last. Pauses while the shopper interacts (touch,
   hover, drag) and resumes shortly after; follows the shopper's current
   position rather than fighting it. */
(function () {
  if (window.__millianGalleryAutoplay) return;
  window.__millianGalleryAutoplay = true;

  var INTERVAL_MS = 5000;
  var RESUME_AFTER_MS = 8000;

  function setup() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.dataset.millianAutoplay) return;
      var list = gallery.querySelector('.product__media-list');
      if (!list) return;
      var slides = list.querySelectorAll('.product__media-item');
      if (slides.length < 2) return;
      gallery.dataset.millianAutoplay = '1';

      var paused = false;
      var resumeTimer = null;

      function pause() {
        paused = true;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, RESUME_AFTER_MS);
      }
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
        gallery.addEventListener(ev, pause, { passive: true });
      });
      gallery.addEventListener('mouseenter', pause);

      setInterval(function () {
        if (paused || document.hidden) return;
        var width = slides[0].clientWidth;
        if (!width) return;
        var current = Math.round(list.scrollLeft / width);
        var next = (current + 1) % slides.length;
        list.scrollTo({ left: slides[next].offsetLeft, behavior: 'smooth' });
      }, INTERVAL_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

/* "You may also like" mobile carousel autoplay: advance one card every 4s,
   looping. Only runs while the grid actually overflows (the mobile snap
   row); pauses on interaction and while the tab is hidden. The grid is
   fetched async by Dawn's product-recommendations, so attach on arrival. */
(function () {
  if (window.__millianRecoAutoplay) return;
  window.__millianRecoAutoplay = true;

  var INTERVAL_MS = 4000;
  var RESUME_AFTER_MS = 8000;

  function attach(grid) {
    if (grid.dataset.millianAutoplay) return;
    grid.dataset.millianAutoplay = '1';

    var paused = false;
    var resumeTimer = null;
    function pause() {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, RESUME_AFTER_MS);
    }
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      grid.addEventListener(ev, pause, { passive: true });
    });

    setInterval(function () {
      if (paused || document.hidden) return;
      if (grid.scrollWidth <= grid.clientWidth + 4) return;
      var items = grid.querySelectorAll('.grid__item');
      if (items.length < 2) return;
      var step = items[1].offsetLeft - items[0].offsetLeft;
      if (step <= 0) return;
      var current = Math.round(grid.scrollLeft / step);
      var next = (current + 1) % items.length;
      grid.scrollTo({ left: items[next].offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
    }, INTERVAL_MS);
  }

  function scan() {
    document.querySelectorAll('product-recommendations .product-grid').forEach(attach);
  }

  function init() {
    scan();
    document.querySelectorAll('product-recommendations').forEach(function (el) {
      new MutationObserver(scan).observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
